import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { createIntroSlice } from '../../data';
import { SliceLayoutIntro } from '../slice-layouts';
import { EntityTitleHeader, useUpcomingEvents } from '@shapeable/ui';
import { BANNER_BLUE_BG, COLOR_LIGHT_BROWN } from '../../theme';

// -------- Child Component Props -------->

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
};

export const PageLayoutEvents: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;
  const introSlice = createIntroSlice(entity);
  introSlice.backgroundColor = COLOR_LIGHT_BROWN;

  const events = useUpcomingEvents();
  
  return (
    <My.Container className={className}>
      <EntityTitleHeader backgroundImage={BANNER_BLUE_BG} entity={entity} />
      <SliceLayoutIntro entity={introSlice} />
      {slices}
    </My.Container>
  )
};
